import { formatOptions } from '@/utils/tool'
import { getElColorPrimary } from '@/utils/theme-color'

/** 威胁等级对后端的映射 */
export enum ThreatLevel {
  /** 未知 */
  unknown = 0,
  /** 未发现威胁 */
  none = 1,
  /** 低危 */
  low = 2,
  /** 中危 */
  medium = 3,
  /** 高危 */
  high = 4,
}

/** 威胁等级描述 */
export enum ThreatLevelDescribe {
  /** 未知 */
  unknown = '未知',
  /** 未发现威胁 */
  none = '未发现威胁',
  /** 低危 */
  low = '外部扫描探测、流氓软件、赌博色情违规、可疑标记等',
  /** 中危 */
  medium = '蠕虫、僵尸、挖矿木马、钓鱼',
  /** 高危 */
  high = '漏洞攻击、窃密、远控、勒索、APT等可能产生极大安全风险的',
}

/** 威胁等级色号 */
export enum ThreatLevelColor {
  /** 未知 */
  unknown = '#949494',
  /** 未发现威胁（静态回退 #0057B4；展示请用 resolveThreatLevelColor） */
  none = '#0057B4',
  /** 低危 */
  low = '#E8A013',
  /** 中危 */
  medium = '#FA6D07',
  /** 高危 */
  high = '#E54545',
}

/** 威胁等级展示色（「未发现威胁」随主题主色变化） */
export function resolveThreatLevelColor (level: ThreatLevel): string {
  if (level === ThreatLevel.none) {
    return getElColorPrimary()
  }
  return ThreatLevelColor[level] ?? ThreatLevelColor.unknown
}

/** 威胁等级Icon */
export const ThreatLevelIcon = {
  /** 未知 */
  unknown: 'components/safety-tags/icons/risk-unknown',
  /** 未发现威胁 */
  none: 'components/safety-tags/icons/risk-none',
  /** 低危 */
  low: 'components/safety-tags/icons/risk-low',
  /** 中危 */
  medium: 'components/safety-tags/icons/risk-medium',
  /** 高危 */
  high: 'components/safety-tags/icons/risk-high',
}

/** 威胁等级背景图 */
export const ThreatLevelBgImg = {
  /** 未知 */
  unknown: require('@/components/safety-tags/_images/bg-threat-unknown.png'),
  /** 未发现威胁 */
  none: require('@/components/safety-tags/_images/bg-threat-none.png'),
  /** 低危 */
  low: require('@/components/safety-tags/_images/bg-threat-low.png'),
  /** 中危 */
  medium: require('@/components/safety-tags/_images/bg-threat-medium.png'),
  /** 高危 */
  high: require('@/components/safety-tags/_images/bg-threat-high.png'),
}

/** 威胁等级文案 */
export enum ThreatLevelTitle {
  /** 未知 */
  unknown = '未知',
  /** 未发现威胁 */
  none = '未发现威胁',
  /** 低危 */
  low = '低危',
  /** 中危 */
  medium = '中危',
  /** 高危 */
  high = '高危',
}

export const THREAT_LEVEL_OPTIONS = [
  {
    label: '全部',
    value: undefined
  },
  ...formatOptions(ThreatLevel, ThreatLevelTitle)
]

export const RISK_THREAT_LEVEL_OPTIONS = [
  {
    label: '全部',
    value: undefined
  },
  ...formatOptions(ThreatLevel, ThreatLevelTitle).filter((item) => {
    return item.value as any !== ThreatLevel.unknown
      && item.value as any !== ThreatLevel.none
  })
]
